<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useModuleStore } from '@/stores/moduleStore'
import useEnvironmentStore from '@/stores/environmentStore'
import ModuleItem from '@/components/domain/ModuleItem.vue'
import { WhatNowContext } from '@/types'
import { computed, provide } from 'vue'
import { ModuleLocaleKey } from '@/i18n/moduleLocaleContext'
import { createScaleForPalette } from '@/ui/palettes'
import { ColorScaleKey } from '@/ui/colorScaleContext'

const { currentModule } = storeToRefs(useModuleStore())
const env = useEnvironmentStore()
env.setContextId(WhatNowContext.CurrentSituation)
env.title = 'page-titles.current-situation'

const baseLocale = computed(() => currentModule.value?.baseLocale || 'no')
provide(ModuleLocaleKey, { baseLocale })

const scale = computed(() => createScaleForPalette(env.paletteId, env.paletteMode))
provide(ColorScaleKey, { scale })
</script>

<template>
  <div v-if="currentModule">
    <ModuleItem :module="currentModule"></ModuleItem>
  </div>
  <div v-else>{{$t('common.no-module-selected')}}</div>
</template>

<style scoped>
select {
  width: 100%;
  font-size: inherit;
  border-radius: 8px;
  border: none;
  padding: 8px;
  margin-bottom: 24px;
}
</style>
